export const CLIENT_SCORING_RESULT_MESSAGES = {
  SUCCESS: 'The client scoring result was successfully changed',
};


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/clientScoringResultMessages.js